import {
    BUNDLE_UPDATE,
    VOCU_UPDATE,
    DELIVERABLE_INSTALL,
    DELIVERABLE_UPDATE,
    DISTRO_UPDATE,
    DOWNLOAD_FINISHED,
    DOWNLOAD_IN_PROGRESS,
    FILE_DOWNLOAD,
    FINISHED,
    INSTALLATION_FINISHED,
    INSTALLATION_IN_PROGRESS,
    INSTALLATION_PENDING,
    PACKAGE_INSTALL,
    PACKAGE_UPDATE,
    REBOOT_PENDING,
    SENT_TO_DEVICE,
    UNINSTALLING,
    UNINSTALLATION_FINISHED,
    UNINSTALL_PACKAGE,
} from './deviceRolloutStates';

export const FETCH_ROLLOUT_STATES_LIMIT = 10;
export const POLLING_INTERVAL = 20000;

export const appProgressStates = [
    SENT_TO_DEVICE,
    DOWNLOAD_IN_PROGRESS,
    DOWNLOAD_FINISHED,
    INSTALLATION_IN_PROGRESS,
    INSTALLATION_FINISHED,
    FINISHED,
];

export const distroProgressStates = [
    SENT_TO_DEVICE,
    DOWNLOAD_IN_PROGRESS,
    DOWNLOAD_FINISHED,
    INSTALLATION_IN_PROGRESS,
    INSTALLATION_FINISHED,
    FINISHED,
];

export const deliverableProgressStates = [
    SENT_TO_DEVICE,
    DOWNLOAD_IN_PROGRESS,
    DOWNLOAD_FINISHED,
    INSTALLATION_PENDING,
    INSTALLATION_IN_PROGRESS,
    REBOOT_PENDING,
    INSTALLATION_FINISHED,
    FINISHED,
];

export const bundleProgressStates = [
    SENT_TO_DEVICE,
    DOWNLOAD_IN_PROGRESS,
    DOWNLOAD_FINISHED,
    INSTALLATION_PENDING,
    INSTALLATION_IN_PROGRESS,
    REBOOT_PENDING,
    INSTALLATION_FINISHED,
    FINISHED,
];

export const fileProgressStates = [
    SENT_TO_DEVICE,
    DOWNLOAD_IN_PROGRESS,
    DOWNLOAD_FINISHED,
    FINISHED,
];

export const uninstallProgressStates = [
    SENT_TO_DEVICE,
    UNINSTALLING,
    UNINSTALLATION_FINISHED,
    FINISHED,
];

export const rolloutTypeConfig = {
    [PACKAGE_UPDATE]: {
        progressStates: appProgressStates,
    },
    [PACKAGE_INSTALL]: {
        progressStates: appProgressStates,
    },
    [DISTRO_UPDATE]: {
        progressStates: distroProgressStates,
    },
    [DELIVERABLE_UPDATE]: {
        progressStates: deliverableProgressStates,
    },
    [DELIVERABLE_INSTALL]: {
        progressStates: deliverableProgressStates,
    },
    [BUNDLE_UPDATE]: {
        progressStates: bundleProgressStates,
    },
    [VOCU_UPDATE]: {
        progressStates: bundleProgressStates,
    },
    [FILE_DOWNLOAD]: {
        progressStates: fileProgressStates,
    },
    [UNINSTALL_PACKAGE]: {
        progressStates: uninstallProgressStates,
    },
};
